module.exports = __webpack_public_path__ + "img/gallery-nft-13.87858039.png";